exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Spinner__Spinner__1fiyk {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  background: black;\n}", ""]);

// Exports
exports.locals = {
	"Spinner": "Spinner__Spinner__1fiyk"
};